import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { sandboxRegistry } from '../utils/sandbox-registry';

// Dynamically import sandbox components
const componentMap = {
  // Production components (used as base for experiments)
  'Studio': lazy(() => import('../pages/Studio')),
  'Hub': lazy(() => import('../pages/Hub')),
  'Lens': lazy(() => import('../pages/LensSimplified')), // Using LensSimplified as the current Lens
  'Assessment': lazy(() => import('../pages/Assessment')),

  // Sandbox variations (will be created on demand)
  'StudioUntitled': lazy(() => import('../pages/sandbox/StudioUntitled')),
  'NineCategoryReport': lazy(() => import('../pages/ui/NineCategoryReport')),

  // 9 Category Report Prototypes
  'ReportPrototypesLanding': lazy(() => import('../pages/ui/sandbox/ReportPrototypesLanding')),
  'LensFullModal-v1-template': lazy(() => import('../pages/ui/sandbox/LensFullModal-v1-template')),

  // These will be created when needed:
  // 'StudioRefreshed': lazy(() => import('../pages/sandbox/StudioRefreshed')),
  // 'HubKanban': lazy(() => import('../pages/sandbox/HubKanban')),
  // 'Lens9Category': lazy(() => import('../pages/sandbox/Lens9Category')),
  // 'LensExecutive': lazy(() => import('../pages/sandbox/LensExecutive')),
  // 'AssessmentWizard': lazy(() => import('../pages/sandbox/AssessmentWizard')),
};

const SandboxRouter = () => {
  // Only render in development
  if (!import.meta.env.DEV) {
    return <Navigate to="/" replace />;
  }

  return (
    <Suspense fallback={
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1a73e8]"></div>
      </div>
    }>
      <Routes>
        {/* Generate routes from sandbox registry */}
        {Object.entries(sandboxRegistry).map(([path, config]) => {
          const Component = componentMap[config.component];
          if (!Component) {
            console.warn(`Component ${config.component} not found for path ${path}`);
            return null;
          }
          
          return (
            <Route 
              key={path}
              path={path.replace('ui/', '')} 
              element={<Component />} 
            />
          );
        })}
      </Routes>
    </Suspense>
  );
};

export default SandboxRouter;